define.alias("shared/components/shared/loading-spinner", "settings/components/shared/loading-spinner");